/* eslint-disable import/no-anonymous-default-export */
import type { AxiosResponse } from "axios";
import apiClient from "@utilities/apiClient";
import EndpointsConst from "@consts/EndpointsConst";

class AWSService {
  /**
   * [DELETE]
   * Deletes the object by objectUrl from the content system
   * @param encodedObjectUrl - The URI-encoded URL of the object to delete
   */
  deleteObject(encodedObjectUrl: string): Promise<AxiosResponse> {
    return apiClient.delete(EndpointsConst.API.AWS.DELETE_OBJECT, {
      params: { encodedObjectUrl },
    });
  }

  /**
   * [GET]
   * Retrieves all background video URLs from the content system
   */
  getBackgroundVideos(): Promise<AxiosResponse<string[]>> {
    return apiClient.get(EndpointsConst.API.AWS.GET_BACKGROUND_VIDEOS);
  }
}

export default new AWSService();
